export default "__VITE_ASSET__Cc1S_oaB__"